import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-check-cor-prim-ria_f60b8883c73b935e9c6b0fdb39105450",
  "use": "ic-check-cor-prim-ria_f60b8883c73b935e9c6b0fdb39105450-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"ic-check-cor-prim-ria_f60b8883c73b935e9c6b0fdb39105450\">\n    <path d=\"M5.25 8.743L3.154 6.646 2.8 6.293l-.354.353-.816.817-.354.354.354.353 3.266 3.267.354.353.354-.353 7-7 .353-.354-.353-.353-.817-.817-.354-.354-.353.354-5.83 5.83z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id